if (!customElements.get("scientific-committee-component")) {
  class ScientificCommittee extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: ".scientific-committee__items",
        pagination: ".swiper-pagination",
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev",
      };
      this.classes = {
        grid: "f-grid",
        swiper: "swiper",
        swiperWrapper: "swiper-wrapper",
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items) || 2;
      this.tabletItems = parseInt(this.dataset.tabletItems) || 2;

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {

      this.initSlider();
    }

    initSlider() {
      const isMobile = window.innerWidth < 990;
      const desktopGap = 18;
      const mobileGap = 12;
      const gap = isMobile ? mobileGap : desktopGap;

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
        slidesPerView: "auto",
        spaceBetween: gap,
        initialSlide: 1,
        centeredSlides: isMobile,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: {
          el: this.querySelector(this.selectors.pagination),
          clickable: true,
          type: "bullets",
        },
        breakpoints: {
          990: {
            slidesPerView: this.items,
            centeredSlides: false,
            spaceBetween: desktopGap,
          },
        },
        loop: false,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== "object") {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener("focusin", () => {
            const slide = element.closest(".swiper-slide");
            if (slide && this.sliderInstance.slider) {
              this.sliderInstance.slider.slideTo(
                this.sliderInstance.slider.slides.indexOf(slide),
              );
            }
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === "object") {
        document.addEventListener("shopify:block:select", (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          if (this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(index);
          }
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === "object") {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define("scientific-committee-component", ScientificCommittee);
}
